import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { customSay,  brands } from './about-data';
import { sliderOpt } from 'src/app/shared/data';

@Component( {
	selector: 'about-page',
	templateUrl: './about.component.html',
	styleUrls: [ './about.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush
} )

export class AboutComponent implements OnInit {

	customSay = customSay;
	brands = brands;
	sliderOption = {
		...sliderOpt,
		nav: false,
		dots: true,
		margin: 20,
		loop: false,
		responsive: {
			1200: {
				nav: true
			}
		}
	}

	constructor () {
	}

	ngOnInit (): void {
	}
}
